const portfolioData = [
  {
    id: 0,
    link: "http://95.31.29.96/workspace/conduitclone/dist/conduitclone/browser/",
    title: "Medium Clone Angular, NGRX",
    image: "angularMedimClone.png",
    about: "проект на Angular с использованием NGRX",
  },
  {
    id: 1,
    link: "https://macgvai.github.io/modern-tunes-ExtJS/build/production/ModernTunes/",
    title: "Modern Tunes Sencha ExtJs",
    image: "itunsExt.png",
    about: "",
  },
  {
    id: 2,
    link: "https://macgvai.github.io/ipgTest_2.0/",
    title: "Grid ExtJs",
    image: "grid.png",
    about: "",
  },
  {
    id: 3,
    link: "https://macgvai.github.io/Drink2Go/build/",
    title: "Интернет-магазин кофейных напитков",
    image: "drink2goPrev.png",
    about: "",
  },
  {
    id: 4,
    link: "http://macgvai.github.io/Farm-Products-REACT/",
    title: "Интернет-магазин Фермерские продукты. React",
    image: "farmProducts.png",
    about: "",
  },
  {
    id: 5,
    link: "http://macgvai.github.io/tehnomart/",
    title:
      "Интернет-магазин строительных материалов и инструментов для ремонта",
    image: "tehnomart.png",
    about: "",
  },
  {
    id: 6,
    link: "http://macgvai.github.io/cat-energy/build/",
    title: "cat-energy",
    image: "catEnergy.png",
    about: "",
  },
  {
    id: 7,
    link: "http://macgvai.github.io/sedona/build/",
    title: "SEDONA",
    image: "sedona.png",
    about: "",
  },
  {
    id: 8,
    link: "http://macgvai.github.io/keksobooking/build/",
    title: "keksobooking",
    image: "keksobooking.png",
    about: "",
  },
  {
    id: 9,
    link: "http://macgvai.github.io/uber777/",
    title: "UBER777",
    image: "uber.png",
    about: "",
  },
  {
    id: 10,
    link: "http://macgvai.github.io/tour/",
    title: "турагентство",
    image: "tur.png",
    about: "",
  },
];

export default portfolioData;
